
import Header from '../../components/Header';

function Dashboard() {
    return (
      <div className="App grid-container">
      <Header/>
          <div className="AppContainer">
            <h1>Dashboard</h1>
          </div>
      </div>
    );
  }
  
  export default Dashboard;
  